import { observer } from "mobx-react";
import { useMemo } from "react";
import { isOk } from "@/common/common";
import { CreatePasswordView, Header, SuccessView } from "./createPasswordComponents";
import { CreatePasswordStore } from "./createPasswordDomain";
import { Layout } from "@/containers/DefaultLayout/DefaultLayout";
import { navigateToLogin } from "@/utils/navigation";
import { useRootStore } from "@/stores/RootStoreContext";

const CreatePasswordPage = observer(() => {
  const { http, history } = useRootStore();
  const store = useMemo(() => new CreatePasswordStore(http, history), [http, history]);
  return (
    <Layout maxWidth={"sm"}>
      <Header />
      {isOk(store.result) ? (
        <SuccessView navigateToLogin={() => navigateToLogin(history)} />
      ) : (
        <CreatePasswordView {...store} save={store.save} />
      )}
    </Layout>
  );
});

export default CreatePasswordPage;
